import { render, staticRenderFns } from "./CardImg.vue?vue&type=template&id=7b041e01&scoped=true&"
import script from "./CardImg.vue?vue&type=script&lang=js&"
export * from "./CardImg.vue?vue&type=script&lang=js&"
import style0 from "./CardImg.vue?vue&type=style&index=0&id=7b041e01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b041e01",
  null
  
)

export default component.exports